import { HeroIcon } from '@components/HeroIcon'
import { useCallback, useState } from 'react'
import { Pressable } from 'react-native'
import { Popover, Text, XStack, YStack } from 'tamagui'
import { useTranslation } from 'react-i18next'
import { ContentReportModal } from './ContentReportModal'

interface IContentReportButtonProps {
  schoolProductId: string
  courseId: string
  lessonId?: string
  courseContentId?: string
}

export function ContentReportButton({
  schoolProductId,
  courseId,
  lessonId,
  courseContentId,
}: IContentReportButtonProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { t } = useTranslation('ContentReport')

  const handleReportPress = useCallback(() => {
    setIsMenuOpen(false)
    setIsModalOpen(true)
  }, [])

  return (
    <>
      <Popover
        allowFlip
        placement="bottom-end"
        offset={{ mainAxis: 4 }}
        open={isMenuOpen}
        onOpenChange={setIsMenuOpen}
      >
        <Popover.Trigger asChild>
          <Pressable
            testID="content-report-menu-button"
            onPress={() => setIsMenuOpen(!isMenuOpen)}
          >
            <YStack
              gap="$spacing-inset-quarck"
              alignItems="center"
              p="$spacing-inset-nano"
            >
              <HeroIcon
                icon={['fal', 'ellipsis-vertical']}
                size={21}
                color="$icon-secondary"
              />
            </YStack>
          </Pressable>
        </Popover.Trigger>

        <Popover.Content
          borderWidth={1}
          borderColor="$border-default"
          borderRadius="$border-radius-sm"
          backgroundColor="$bg-surface"
          minWidth={200}
          elevate
        >
          <Pressable testID="content-report-button" onPress={handleReportPress}>
            <XStack
              alignItems="center"
              gap="$spacing-inset-xs"
              p="$spacing-inset-xs"
              borderRadius="$border-radius-sm"
              hoverStyle={{ backgroundColor: '$bg-surface-raised' }}
            >
              <HeroIcon
                icon={['fal', 'megaphone']}
                size={16}
                color="$danger-300"
              />
              <Text
                color="$text-primary"
                fontSize="$font-size-xxs"
                fontFamily="$mulishRegular"
              >
                {t('menuOption')}
              </Text>
            </XStack>
          </Pressable>
        </Popover.Content>
      </Popover>

      <ContentReportModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        schoolProductId={schoolProductId}
        courseId={courseId}
        lessonId={lessonId}
        courseContentId={courseContentId}
      />
    </>
  )
}
